import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import { CDN_LINK } from "@globalConfig";
import stl from "./ReferralComponent.module.css";
import ContactAgentComponent from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/ContactAgentComponent/ContactAgentComponent";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var ReferralComponent = function ReferralComponent(_ref) {
  var referralData = _ref.referralData,
    orderId = _ref.orderId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.ReferralComponent
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.ReferralWrapper
  }, /*#__PURE__*/React.createElement("strong", {
    className: "m-hide"
  }, t("who_used_referral_code", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.cardsWrapper
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/referral-list/".concat(orderId, "/used")),
    className: stl.card
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.details
  }, /*#__PURE__*/React.createElement("strong", null, referralData === null || referralData === void 0 ? void 0 : referralData.used_count), /*#__PURE__*/React.createElement("p", null, t("used_referral_codes", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/hrefArr.svg",
    alt: "Link arrow"
  })), /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/referral-list/".concat(orderId, "/delivered")),
    className: stl.card
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.details
  }, /*#__PURE__*/React.createElement("strong", null, referralData === null || referralData === void 0 ? void 0 : referralData.delivered_count), /*#__PURE__*/React.createElement("p", null, t("delivered_cars", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/hrefArr.svg",
    alt: "Link arrow"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.stickBelow
  }, (referralData === null || referralData === void 0 ? void 0 : referralData.sales_person) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", {
    className: stl.agentTitle
  }, t("contact_sales_representative_inquiries", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement(ContactAgentComponent, {
    details: referralData,
    className: stl.boxShadow
  })), /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/tracking-checkout-details/".concat(orderId)),
    className: stl.backButton
  }, t("back_track_car", {
    ns: "web_tracking"
  })))));
};
export default ReferralComponent;